module.exports = __webpack_public_path__ + "assets/images/premium-features/x-clockin-out-f84ea1.png";